<template>
  <div class="z-10 !fixed bottom-0 w-full">
    <div class="w-full flex justify-around px-4 md:hidden pb-10!">
      <ColorImg
        src="/images/leaderboard/cardHeadForm.svg"
        class="bg-white w-full absolute left-0 bottom-1/2"
        alt=""
      />
      <div class="absolute w-full h-full top-1/2 bg-white"></div>
      <div
        v-for="(tab, i) in [
          { name: 'Matches', icon: 'terrain.svg', id: 'matches' },
          { name: 'Leaders', icon: 'trophee.svg', id: 'leaderboard' },
          {
            name: 'Services',
            icon: 'box.svg',
            event: $constants.EVENTS.SERVICES.START,
            isCenter: true
          },
          { name: 'Historique', icon: 'order-history.svg', id: 'history' },
          { name: 'Profile', icon: 'user.svg', id: 'profile' }
        ]"
        @click="
          () => {
            tab.event && $bus.emit(tab.event);
          }
        "
      >
        <div
          v-if="tab.isCenter"
          class="flex items-center justify-center w-[20vw]"
        >
          <div class="absolute">
            <div
              :class="{
                '!opacity-10 !w-16 !h-16': $route.name == tab.id
              }"
              class="opacity-60 w-20 h-20 rounded-[10px] rotate-45 duration-300"
              style="
                background: linear-gradient(
                  149.07deg,
                  #34c8e8 9.45%,
                  #4e4af2 136.18%
                );
                box-shadow: 0px 20px 30px rgba(16, 20, 28, 0.6);
              "
            >
              <div class="gradient-border border-sm !opacity-40"></div>
            </div>
          </div>
          <div class="absolute">
            <div
              class="w-14 h-14 rounded-[10px] rotate-45 !bg-secondary"
              style="
              "
            ></div>
          </div>
          <div class="absolute w-10 h-10 pl-1 pb-1 ">
            <ColorImg src="/images/logo-white.svg" alt="" class="w-full h-full bg-white" />
          </div>
        </div>
        <component
          v-else
          :is="tab.id ? 'router-link' : 'div'"
          :to="`${tab.id}`"
          class="flex flex-col items-center gap-3 rounded-2xl duration-300 relative"
          :class="{
            'text-[#010101] font-bold': $route.name == tab.id,
            'text-[#010101] opacity-70': $route.name !== tab.id
          }"
        >
          <ColorImg
            :src="`/images/icons/${tab.icon}`"
            class="w-7 h-7 bg-current"
          />
          <div class="w-[19vw] text-center text-xs">
            {{ tab.name }}
          </div>
        </component>
      </div>
    </div>
  </div>
</template>
